import { render, staticRenderFns } from "./SystemTransactionView.vue?vue&type=template&id=67c6ee8e"
import script from "./SystemTransactionView.vue?vue&type=script&lang=js"
export * from "./SystemTransactionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports